import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { BrowserRouter } from 'react-router-dom'
import { queryClient } from './lib/react-query'
import { AppRoutes } from './routes'
import './lib/i18n'

/**
 * App Root Component
 *
 * ⚠️ Important: AgencyProvider and AgencyAssetsProvider are NOT applied here.
 * They are only applied to /app/* routes that require agency branding.
 * Public routes (landing page, etc.) use default Kopro branding.
 */
export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
